import React, {FC, useContext, useState} from "react";
import {ModerationUser} from "interfaces";
import {ModerationRow} from "components/ModerationRow";
import Highlighter from "react-highlight-words";
import {ModerationHint} from "components/ModerationHint";
import {isShowHideAboutSupported, UserReviewTags} from "enums";
import {handleTranslation} from "utils/translator";
import {getAbuseWords} from "utils/getAbuseWords";
import {FaEyeSlash, FaRegEye} from "react-icons/fa";
import {usersService} from "services";
import {AuthContext} from "contexts";
import {Events, eventTracker, ModerationSources} from "utils/eventTracker";
import {questionsStore} from "stores";

interface Props {
    user: ModerationUser
    onUserChange: (user: ModerationUser) => void;
}


export const ModerationAbout: FC<Props> = ({user, onUserChange}) => {
    const {env} = useContext(AuthContext);
    const [translatedVersion, setTranslatedVersion] = useState('');

    const aboutAbuseReviewTag = user.reviewTags.find(r => {
        const infoParts = r.info?.split(', text: ') ?? [];
        return infoParts.length > 0 ? user.about?.split(infoParts[1]).length > 1 : false;
    });
    const isBannedAbuse = aboutAbuseReviewTag?.tag === UserReviewTags.BannedAbout;

    const abuseWords = getAbuseWords(aboutAbuseReviewTag?.info ?? '');

    const toggleAboutVisibility = async () => {
        if (!env) {
            return
        }

        await usersService.toggleAboutVisibility(user.id, env, !user.isAboutVisible)
        const eventParams = eventTracker.getReviewParams(user, null, ModerationSources.Moderation);
        eventTracker.track(Events.about, {...eventParams, type: user.isAboutVisible ? 'hide' : 'show'})
        onUserChange({...user, isAboutVisible: !user.isAboutVisible})
    }


    const renderTranslator = () => {
        return <div className={`mt-2 ${translatedVersion ? 'rounded border border-dark p-1' : ''}`}>
            {translatedVersion ? <span className="fw-bold">Перевод:</span> :
                <a href="#"
                   className="text-black-50 text-decoration-underline"
                   style={{cursor: 'pointer'}}
                   onClick={async (event) => {
                       event.preventDefault();
                       const translatedText = await handleTranslation(user.about)
                       setTranslatedVersion(translatedText)
                   }}>
                    Перевести на английский
                </a>
            }
            <div> {translatedVersion}</div>
        </div>
    }

    const renderVisibilityButton = () => {
        if (!isShowHideAboutSupported(env)) {
            return null
        }
        return <ModerationHint
            className={`${user.isAboutVisible ? 'alert-secondary text-black' : 'alert-warning'} py-1 d-flex flex-row align-items-center`}>
            Пользователи сейчас {user.isAboutVisible ? 'видят' : 'не видят'} этот
            About в поиске
            <button type="button"
                    className="btn btn-secondary btn-sm d-flex flex-row align-items-center mx-2"
                    onClick={toggleAboutVisibility}
                    title={user.isAboutVisible ? 'Уберет видимость About в поиске' : 'Добавить видимость About в поиске на случай неправильной работы триггера'}>
                {user.isAboutVisible ?
                    <FaEyeSlash size={14} style={{marginRight: 4}}/> :
                    <FaRegEye size={14} style={{marginRight: 4}}/>}
                {user.isAboutVisible ? 'Скрыть' : 'Показать'}
            </button>
        </ModerationHint>
    }

    const renderAbout = () => {
        if (!abuseWords.length) {
            return <div>
                {renderVisibilityButton()}
                <div className="flex-grow-1">
                    {user.about}
                    {renderTranslator()}
                </div>
            </div>;
        }

        return <div>
            {renderVisibilityButton()}
            <div className="flex-grow-1">
                <Highlighter
                    highlightClassName={isBannedAbuse ? "bg-danger text-white" : "bg-warning"}
                    searchWords={abuseWords}
                    autoEscape={true}
                    textToHighlight={user.about}
                />
                <ModerationHint
                    className={isBannedAbuse ? 'alert-danger fw-normal mt-3' : 'alert-warning fw-normal mt-3'}>Пользователь
                    использовал триггерные
                    слова: {<span className="fw-bold">{abuseWords.join(', ')}</span>}</ModerationHint>
                {renderTranslator()}
            </div>

        </div>
    }

    if (!user.about && !user.aboutAnswers.length) {
        return null
    }

    return <>
        {user.about && <ModerationRow label={"O ceбе"} value={
            renderAbout()}/>}
        {!!user.aboutAnswers.length &&
            <ModerationRow label={"Промты"} value={
                <div>
                    {user.aboutAnswers.map(a => {
                        const question = questionsStore.questions.find(q => q.tag === a.tag)
                        return <div key={a.text}>
                            <small>{question?.text ?? a.tag}</small>
                            <p key={a.tag}>{a.text}</p>
                        </div>
                    })}
                </div>}
            />}
    </>

}